module.exports = __webpack_public_path__ + "img/HZ-P6010.d1553795.jpg";